import Rete from 'rete'

export default class NodeEditor {
  static create(version, element) {
    return new Rete.NodeEditor(version, element)
  }
}